// Libraries
import { Fragment } from 'react';
// Utils
import { Rating } from '@utils/constants';
import { colors } from '@theme/foundations';

/**
 * Represents a gradient component used in the chart to create a gradient fill for data points
 * regarding the rating values.
 *
 * @component
 *
 * @returns {ReactElement} - A React element representing the gradient for the ratings.
 */

export const GradientComponent = () => {
  const generateStops = (initialRate: Rating, finalRate: Rating) => {
    const startColor = colors.ratings[initialRate].dark;
    const endColor = colors.ratings[finalRate].dark;

    return (
      <Fragment>
        <stop offset='0%' stopColor={startColor} />
        <stop offset='100%' stopColor={endColor} />
      </Fragment>
    );
  };

  return (
    // Create an SVG element with the linear gradients using the stops
    <svg>
      <defs>
        {Object.values(Rating).map((initialRate) => {
          return Object.values(Rating).map((finalRate) => {
            const gradientId = `${initialRate}to${finalRate}`;

            return (
              <linearGradient key={gradientId} id={gradientId}>
                {generateStops(initialRate, finalRate)}
              </linearGradient>
            );
          });
        })}
      </defs>
    </svg>
  );
};
